import React from 'react';
import ReactDOM from 'react-dom/client';
import Landing from './Landing';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Landing />
  </React.StrictMode>
);
